/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSaveArticleButton from 'sites/allas/components/standalone/SaveArticleButton';

export const DynamicStandaloneSaveArticleButton = StandaloneSaveArticleButton;
export type DynamicStandaloneSaveArticleButtonProps = PropsFromComponent<typeof StandaloneSaveArticleButton>;

export const DynamicStandaloneSaveArticleButtonWith = (extras: DynamicStandaloneExtras): typeof StandaloneSaveArticleButton => {
    return function DynamicStandaloneSaveArticleButton(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SaveArticleButton');
        return <StandaloneSaveArticleButton {...mergeProps({ options: { theme } }, props)} />;
    }
}